<div class="flex flex-col h-full" *ngIf="!loaders.page && keyDataKlixi">

  <!-- background -->
  <div class="flex flex-col h-full items-center" style="position: relative; z-index: 1;">

    <div class="pos-img-cont absolute-bg"
         [ngStyle]="{'background-image': 'url(' + ( keyDataKlixi.point_of_sale.background.length > 0 ?  keyDataKlixi.point_of_sale.background[2] : '') + ')'}"
         [ngStyle.xs]="{'background-image': 'url(' + ( keyDataKlixi.point_of_sale.background.length > 0 ?  keyDataKlixi.point_of_sale.background[0] : '') + ')'}">
    </div>

    <div class="flex flex-col w-full h-full items-center p-6" style="z-index: 2;">

      <div class="flex flex-col items-center h-auto my-auto w-full md:w-[650px]" [ngClass]="cssService.cardClass">

        <!-- Réservation innactive -->
        <div *ngIf="!bookingActive" class="p-8">
          <div class="mat-title">{{"booking.no_active" |translate}}</div>
        </div>

        <!-- Réservation KLIXI active -->
        <div *ngIf="bookingActive">

          <div class="py-4">

            <!-- Point of sale title -->
            <div class="p-4 flex flex-row gap-4 items-center">
              <div class="w-20">
                <img
                  [src]="(keyDataKlixi.point_of_sale && keyDataKlixi.point_of_sale.img) ? keyDataKlixi.point_of_sale.img : 'assets/img/logo/logo-fulle-xs.png'"
                  class="h-full object-contain" style="border-radius: 50%;">
              </div>
              <div class="flex flex-col">
                <div class="text-lg font-bold">{{keyDataKlixi.point_of_sale.name_webshop}}</div>
                <div class="text-sm">{{keyDataKlixi.point_of_sale.address}}, {{keyDataKlixi.point_of_sale.postal}} {{keyDataKlixi.point_of_sale.city}}</div>
              </div>
            </div>

            <div class="openHomeBE"></div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
